import script from "./index.vue?vue&type=script&setup=true&lang=js"
export * from "./index.vue?vue&type=script&setup=true&lang=js"

import "./index.vue?vue&type=style&index=0&id=40664ec7&rel=stylesheet%2Fscss&lang=scss&scoped=true"
import "./index.vue?vue&type=style&index=1&id=40664ec7&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-40664ec7"]])

export default __exports__